import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCardCheckFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.7071 15.2929C23.0976 15.6834 23.0976 16.3166 22.7071 16.7071L18.7071 20.7071C18.3166 21.0976 17.6834 21.0976 17.2929 20.7071L15.2929 18.7071C14.9024 18.3166 14.9024 17.6834 15.2929 17.2929C15.6834 16.9024 16.3166 16.9024 16.7071 17.2929L18 18.5858L21.2929 15.2929C21.6834 14.9024 22.3166 14.9024 22.7071 15.2929Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.16146 4L18.8385 4C19.3657 3.99999 19.8205 3.99997 20.195 4.03057C20.5904 4.06288 20.9836 4.13419 21.362 4.32699C21.9265 4.61461 22.3854 5.07355 22.673 5.63803C22.8658 6.01641 22.9371 6.40963 22.9694 6.80498C23 7.17954 23 7.6343 23 8.16144C23 8.62456 22.6246 9 22.1614 9H1.83859C1.37545 9 1 8.62455 1 8.16141C0.999985 7.63431 0.999972 7.17952 1.03057 6.80498C1.06287 6.40963 1.13419 6.01641 1.32698 5.63803C1.6146 5.07355 2.07355 4.6146 2.63803 4.32698C3.01641 4.13419 3.40963 4.06287 3.80498 4.03057C4.17953 3.99997 4.63435 3.99998 5.16146 4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.6 11C2.03995 11 1.75992 11 1.54601 11.109C1.35785 11.2049 1.20487 11.3578 1.10899 11.546C1 11.7599 1 12.0399 1 12.6V15.8385C0.999985 16.3656 0.999972 16.8205 1.03057 17.195C1.06287 17.5904 1.13419 17.9836 1.32698 18.362C1.6146 18.9265 2.07355 19.3854 2.63803 19.673C3.01641 19.8658 3.40963 19.9371 3.80498 19.9694C4.17949 20 4.63416 20 5.1612 20L11.9729 20C12.5236 20 12.7989 20 12.9128 19.9362C13.049 19.8598 13.0751 19.83 13.1329 19.6849C13.1812 19.5636 13.1295 19.1748 13.0263 18.3972C12.9075 17.5031 13.1916 16.5657 13.8787 15.8787C15.0095 14.7478 16.8186 14.7085 17.9966 15.7608L19.8787 13.8787C20.5784 13.1789 21.5379 12.8971 22.4468 13.0333C22.7224 13.0746 23 12.8787 23 12.6C23 12.04 23 11.7599 22.891 11.546C22.7951 11.3578 22.6422 11.2049 22.454 11.109C22.2401 11 21.9601 11 21.4 11H2.6Z",
			fill: "currentColor"
		})
	]
});
export default SvgCreditCardCheckFilled;
